module.exports = __webpack_public_path__ + "static/media/04.3bec9591.jpg";